

<template>
  <div id="app" v-cloak>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="less">
 [v-cloak] {
      display: none;
    }
@import 'common/css/reset.css';
@import 'common/css/common.css';
@import 'assets/font/font.css';
</style>
